export const ENV_VARS = {
  BASE_API_URL: process.env.NEXT_PUBLIC_BASE_API_URL
    ? `${process.env.NEXT_PUBLIC_BASE_API_URL}`
    : "http://localhost:8000/api",
  BLOCK_PLUS_EMAIL_EXTENSION:
    process.env.NEXT_PUBLIC_BLOCK_PLUS_EMAIL_EXTENSION,
  // https://vercel.com/docs/environment-variables/system-environment-variables#VERCEL_ENV
  VERCEL_ENV: process.env.VERCEL_ENV as
    | "production"
    | "preview"
    | "development",
};

export const BASE_API_URL = ENV_VARS.BASE_API_URL;
export const MODEL_BASE_URL = `${ENV_VARS.BASE_API_URL}/openai/v1`;
export const INTERNAL_MODEL_BASE_URL = `${ENV_VARS.BASE_API_URL}/internal/v1`;
export const PLATFORM_BASE_URL = `${ENV_VARS.BASE_API_URL}/platform/v1`;
export const CHAT_COMPLETION_URL = `${MODEL_BASE_URL}/chat/completions`;

export const SHORT_SESSION_ORG_IDS = [
  "org_01jmye5jc6fd2rdpjty5k8exmr",
  "org_01jh5jjb8kftj9nhne3w87ejjg",
  "org_01jk3bh91aekbt2mecfhkvzgqf",
];
export const SHORT_SESSION_DURATION_MINUTES = 30;
